import React from "react";
import styles from "./CardContent.module.css";

function CardContent({children}) {
  return <div className={styles.container}>{children}</div>
}

export default CardContent;